export default "__VITE_ASSET__DH6Nn0p9__"